// extracted by mini-css-extract-plugin
module.exports = {"password":"livestream-event-CourseSessionRecording__password--2CtJF"};